import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Menu from './Menu';

export default function Section(props) {
    const {
        background,
        head,
        color = 'white',
        className,
        noPadding,
        children,
    } = props;

    return (
        <div
            className={classNames(
                'w-screen',
                !noPadding && 'py-10',
                color === 'black' && 'section-black',
                color === 'white' && 'section-white',
                color === 'lightgray' && 'section-lightgray',
                color === 'steelgray' && 'section-steelgray',
                background && 'z-0 relative',
                className,
            )}
        >
            {background
            && (
            <div className="absolute top-0 w-full h-full -z-50">
                {background}
            </div>
            )}
            <div className={classNames('w-10/12 mx-auto 2xl:max-w-screen-2xl', !head && 'py-6')}>
                {head && <Menu white={!!background || ['steelgray', 'black'].includes(color)} selected={typeof head === 'boolean' ? undefined : head} />}
                {children}
            </div>
        </div>
    );
}

Section.defaultProps = {
    background: null,
    children: null,
    className: null,
    color: 'white',
    head: false,
    noPadding: false,
};

Section.propTypes = {
    background: PropTypes.node,
    children: PropTypes.node,
    className: PropTypes.string,
    color: PropTypes.oneOf(['black', 'white', 'lightgray', 'steelgray']),
    head: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool,
        PropTypes.node,
    ]),
    noPadding: PropTypes.bool,
};
